import { render, staticRenderFns } from "./chartsPieRing.vue?vue&type=template&id=64a98dd2&scoped=true&"
import script from "./chartsPieRing.vue?vue&type=script&lang=js&"
export * from "./chartsPieRing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a98dd2",
  null
  
)

export default component.exports